import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

export const UnsavedMenuDialogModes = {
  CHANGE_MENU: 'change_menu',
  PACK_HOTKEYS: 'pack_hotkeys'
}

export default function UnsavedMenuDialog (props) {
  const {
    open,
    onClose,
    onContinue,
    show,
    menuElement = null,
    mode
  } = props

  const [showDialog, setShowDialog] = React.useState(false)

  React.useEffect(() => {
  }, [])

  React.useEffect(() => {
    // if we are trying to open the dialog
    if (open) {
      if (!show) {
        onContinue(menuElement, mode) // just trigger the continue event

        return // and dont show the dialog
      }
    }

    setShowDialog(open)
  }, [open])

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    onClose(event, reason)
  }

  const saveButtonDescription = () => {
    let buttonText = 'Save and '

    if (mode === UnsavedMenuDialogModes.CHANGE_MENU) {
      buttonText += 'Open Menu'
    } else if (mode === UnsavedMenuDialogModes.PACK_HOTKEYS) {
      buttonText += 'Continue' // we don't want to put the word Publish here, as the Publish dialog will appear after clicking the button
    }

    return (buttonText)
  }

  return (
    <Dialog maxWidth="xs" fullWidth={true} open={showDialog} onClose={handleClose}>
      <DialogTitle>Unsaved Hotkey Changes</DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12}>
            <Typography>You have unsaved Hotkey changes - you must save them to continue.</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={() => onContinue(menuElement, mode)} color="primary">
          <CheckCircleIcon />&nbsp;
          {
            saveButtonDescription()
          }
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UnsavedMenuDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  menuElement: PropTypes.object,
  mode: PropTypes.string.isRequired
}
